import { KvSyncApi, KvSyncApiV2Wrapper } from '@ahaslides-product/frontend-toolkit'
import Vue from 'vue'
import config from '@/config'

const kvSyncApi = KvSyncApi(Vue, config)
const kvSyncApiV2 = KvSyncApiV2Wrapper(Vue, config)

export const getKvSyncApi = (canSubscribeNewKafkaCluster) => {
  return canSubscribeNewKafkaCluster && config.kvSyncApiBasePath ? kvSyncApiV2 : kvSyncApi
}

export const initResources = () => {
  kvSyncApi.initResource()
  kvSyncApiV2.initResource()
}
